import React, { useState, useEffect } from "react";
import api from "../../../../../api";

const WorkingHoursCard = () => {
  const [libraryHoursTitle, setLibraryHoursTitle] = useState("");
  const [libraryDays, setLibraryDays] = useState([]);
  const [libraryTimes, setLibraryTimes] = useState([]);
  const [libraryIcons, setLibraryIcons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await api.get("/api/sitepages/about-us/library");

        const workingCard = response.data.groups[0].working_hours_card;

        setLibraryHoursTitle(workingCard.title || "Working Hours");
        setLibraryDays(workingCard.sub_heading || []);
        setLibraryTimes(workingCard.sub_heading_description || []);
        setLibraryIcons(workingCard.icons || []);

      } catch (error) {
        console.error("Error fetching library data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  if (loading) return null;

  return (
    <>
      {/* ⭐ DESKTOP VERSION (unchanged) */}
      <div className="card hours-card position-absolute d-none d-md-block">
        <div className="card-header">
          <i className="fa fa-clock-o me-2"></i>
          <span dangerouslySetInnerHTML={{ __html: libraryHoursTitle }} />
        </div>

        <div className="card-body p-0">
          {libraryDays.map((day, index) => (
            <div
              key={index}
              className={`hours-item ${
                libraryTimes[index] === "Closed" ? "closed-item" : ""
              }`}
            >
              <div className="hours-icon">
                <i className={`fa ${libraryIcons[index] || "fa-calendar"}`}></i>
              </div>

              <div className="hours-content">
                <div
                  className="hours-day"
                  dangerouslySetInnerHTML={{ __html: day }}
                />

                <div
                  className="hours-time"
                  dangerouslySetInnerHTML={{
                    __html: libraryTimes[index] || "—",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ⭐ MOBILE VERSION (your exact HTML converted to React) */}
      <section className="d-flex justify-content-center d-md-none mt-3">
        <div className="card hours-card animate__animated animate__fadeInUp">
          <div className="card-header">
            <i className="fa fa-clock-o me-2"></i>
            <span dangerouslySetInnerHTML={{ __html: libraryHoursTitle }} />
          </div>

          <div className="card-body p-0">
            {libraryDays.map((day, index) => (
              <div
                key={index}
                className={`hours-item animate__animated animate__fadeIn animate__delay-${index + 1}s ${
                  libraryTimes[index] === "Closed" ? "closed-item" : ""
                }`}
              >
                <div className="hours-icon">
                  <i className={`fa ${libraryIcons[index] || "fa-calendar"}`} />
                </div>

                <div className="hours-content">
                  <div
                    className="hours-day"
                    dangerouslySetInnerHTML={{ __html: day }}
                  />
                  <div
                    className="hours-time"
                    dangerouslySetInnerHTML={{
                      __html: libraryTimes[index] || "—",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WorkingHoursCard;
